import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {suppliersUnitsStore} from '@store/suppliers/units/suppliers-units.store';
import {getSuppliersUnitsDataSource} from '@store/suppliers/units/suppliers-units.requests';

export class SuppliersUnitsQuery {
  store = suppliersUnitsStore;

  status$ = this.store.pipe(select((state) => state.status));
  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  suppliersUnits$ = getSuppliersUnitsDataSource.data$();
  selectedSuppliersUnits$ = this.store.pipe(
    selectManyByPredicate((suppliersUnitUI) => suppliersUnitUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const suppliersUnitsQuery = new SuppliersUnitsQuery();